import Dropzone from './components/Dropzone';
import reducer, { UploadState } from './reducers';

export default reducer;
export {
  Dropzone,
};
export type {
  UploadState,
};
